import { FormTabHeader } from '../../../mad_shared/form-tab-header/form-tab-header.types'
import { HotelFormState } from './hotel-comparable-form-state'

export function mapHotelComparableFormTabs(state: HotelFormState): FormTabHeader[] {
    return [
        {
            label: 'Location & Building',
            state: 'default'
        },
        {
            label: 'Property Information',
            state: 'default'
        },
        {
            label: 'ESG Indicators',
            state: 'default'
        },
        {
            label: 'Lease & Sale Information',
            state: 'default'
        },
        {
            label: 'Pictures & Documents',
            state: 'default'
        }
    ]
}